
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import * as mGender from '~/consts/genders'

export default Vue.extend({
  props: {
    percent: {
      type: Number,
      required: true,
    },
    genderType: {
      type: String,
      required: true,
    },
    type: {
      type: Object,
      required: true,
    } as PropOptions<mGender.SliderType>,
  },
  computed: {
    percentStyle() {
      if (this.type !== mGender.SLIDER_TYPE.Bar) {
        return { '--width': '100%' }
      }

      return { '--width': `${this.percent}%` }
    },
    percentBarInnerClass() {
      if (this.type === mGender.SLIDER_TYPE.Both) {
        return 'bar--both'
      }
      return ''
    },
    percentBarClass() {
      if (this.type !== mGender.SLIDER_TYPE.Both) {
        return 'percentBar'
      }
      return ''
    },
    genderTypeClass() {
      return {
        'sexualities--sex': this.genderType === 'sex',
        'sexualities--genderIdentity': this.genderType === 'gender_identity',
        'sexualities--genderExpression': this.genderType === 'gender_expression',
        'sexualities--sexualOrientation': this.genderType === 'sexual_orientation',
        'sexualities--romanticOrientation': this.genderType === 'romantic_orientation',
      }
    },
  },
})
